import { useTranslation } from "react-i18next";import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';

const PLANS = [
{
  id: 'starter',
  name: 'Starter',
  monthly: 200,
  annual: 160,
  desc: 'For independent landlords managing internal records.',
  cta: 'Start free trial',
  to: '/register',
  featured: false,
  features: [
  'Up to 100 units',
  '2 Admin seats',
  'Buildings & Units mgmt',
  'Double-Entry Block Ledger',
  'Manual Rent Tracking',
  'Basic Financial Reports',
  'Email Notifications']

},
{
  id: 'pro',
  name: 'Pro',
  monthly: 300,
  annual: 240,
  desc: 'For professional firms with automated admin workflows.',
  cta: 'Get access',
  to: '/register',
  featured: true,
  badge: 'Most popular',
  features: [
  'Up to 150 units',
  '5 Admin seats',
  'Global Maintenance Hub',
  'Security Deposit Compliance',
  'Automated Monthly Statements',
  'WhatsApp Reminders',
  'Owner Mgmt & Work Orders',
  'Occupancy Analytics',
  'Booking, Waitlist & Transfers',
  'Standard Priority Support']

},
{
  id: 'enterprise',
  name: 'Enterprise',
  monthly: null,
  annual: null,
  desc: 'Institutional-grade control with full self-service portals.',
  cta: 'Talk to sales',
  to: '/contact',
  featured: false,
  features: [
  'Unlimited Units & Admins',
  'Tenant & Owner Portals',
  'Two-Way Secure Messaging',
  'Stripe E2E Rent Payments',
  'Automated Email System',
  'Digital Contract Signing',
  'Multi-Organization Support',
  'Custom Report Templates',
  'Advanced Activity Logs',
  'API & Webhook Access',
  '2FA via WhatsApp OTP']

}];


export default function Pricing() {const { isDarkMode } = useTheme();
  const { t } = useTranslation();
  const [annual, setAnnual] = useState(true); // Default to annual on home

  return (
    <section id="pricing" className={`py-40 px-6 sm:px-12 lg:px-24 border-t relative overflow-hidden ${isDarkMode ? 'bg-[#0a0a0b] text-zinc-100 border-white/5' : 'bg-white text-zinc-900 border-zinc-100'}`}>
            {/* ── Background Image ────────────────────────── */}
            <div
        className="absolute inset-0 z-0 pointer-events-none"
        style={{
          backgroundImage: 'url("/assets/pricing-bg.png")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          opacity: isDarkMode ? 0.3 : 0.4,
          filter: isDarkMode ? 'none' : 'grayscale(0.1) contrast(1.05)'
        }} />
      
            {/* Subtle Overlay to ensure legibility while showing more image */}
            <div className={`absolute inset-0 z-0 pointer-events-none ${isDarkMode ? 'bg-gradient-to-b from-[#0a0a0b]/70 via-transparent to-[#0a0a0b]/70' : 'bg-gradient-to-b from-white/80 via-white/40 to-white/80'}`} />

            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Instrument+Serif:ital@0;1&family=Inter:wght@300;400;500;600&display=swap');

                .editorial-title {
                    font-family: 'Instrument Serif', serif;
                    letter-spacing: -0.02em;
                }

                .pr-toggle-wrap {
                    display: inline-flex;
                    align-items: center;
                    background: ${isDarkMode ? 'rgba(20,20,23,0.8)' : 'rgba(244,244,245,0.8)'};
                    backdrop-filter: blur(12px);
                    padding: 4px;
                    border-radius: 10px;
                    border: 1px solid ${isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.05)'};
                    position: relative;
                    z-index: 10;
                }

                .toggle-opt {
                    padding: 6px 16px;
                    border-radius: 6px;
                    font-size: 13px;
                    font-weight: 500;
                    cursor: pointer;
                    transition: all 0.2s ease;
                }

                .toggle-opt.selected {
                    background: ${isDarkMode ? '#27272a' : '#fff'};
                    color: ${isDarkMode ? '#fff' : '#000'};
                    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
                }

                /* ── Card System (Restored Grid) ──────────── */
                .pr-grid {
                    display: grid;
                    grid-template-columns: 1fr;
                    gap: 1px;
                    background: ${isDarkMode ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.08)'};
                    border: 1px solid ${isDarkMode ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.08)'};
                    border-radius: 24px;
                    overflow: hidden;
                    position: relative;
                    z-index: 10;
                    backdrop-filter: blur(8px);
                }
                @media (min-width: 1024px) {
                    .pr-grid { grid-template-columns: repeat(3, 1fr); }
                }

                .pr-card {
                    padding: 64px 48px;
                    background: ${isDarkMode ? 'rgba(10,10,11,0.7)' : 'rgba(255,255,255,0.7)'};
                    backdrop-filter: blur(16px);
                    display: flex;
                    flex-direction: column;
                    transition: background 0.3s ease;
                }

                .pr-card:hover {
                    background: ${isDarkMode ? 'rgba(14,14,15,0.85)' : 'rgba(250,250,250,0.85)'};
                }

                .pr-btn-main {
                    height: 48px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 100px;
                    font-size: 13px;
                    font-weight: 400;
                    letter-spacing: 0.3px;
                    color: ${isDarkMode ? 'rgba(255,255,255,0.85)' : 'rgba(0,0,0,0.6)'};
                        border: 1px solid ${isDarkMode ? 'rgba(255,255,255,0.25)' : 'rgba(0,0,0,0.15)'};
                    background: ${isDarkMode ? 'rgba(255,255,255,0.05)' : 'rgba(255,255,255,0.2)'};
                    backdrop-filter: blur(10px);
                    transition: all 0.22s ease;
                    text-decoration: none;
                }

                .pr-btn-main:hover {
                    color: ${isDarkMode ? '#fff' : '#000'};
                    border-color: ${isDarkMode ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.4)'};
                    background: ${isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(255,255,255,0.4)'};
                    transform: translateY(-1px);
                }

                .feature-dot {
                    width: 4px; height: 4px; border-radius: 50%;
                    background: #dc2626; margin-top: 8px; flex-shrink: 0;
                }

                .feature-text {
                    font-size: 14px; line-height: 1.6;
                    color: ${isDarkMode ? 'rgba(255,255,255,0.9)' : '#000'};
                }
            `}</style>

            <div className="max-w-7xl mx-auto relative z-10">
                <div className="flex flex-col items-center text-center mb-24">
                    <span className="text-[10px] font-bold tracking-[0.3em] uppercase text-red-600 mb-6 block">
                        {t("our_tiers")}
                    </span>
                    <h2 className="editorial-title text-5xl md:text-7xl font-normal leading-tight mb-8">
                        {t("choose_the_right")} <span className={`italic ${isDarkMode ? 'opacity-70' : 'opacity-50'} underline decoration-1 underline-offset-8`}>{t("plan_for_you")}</span>
                    </h2>

                    <div className="pr-toggle-wrap">
                        <div className={`toggle-opt ${!annual ? 'selected' : ''}`} onClick={() => setAnnual(false)}>{t("monthly_1")}</div>
                        <div className={`toggle-opt ${annual ? 'selected' : ''}`} onClick={() => setAnnual(true)}>{t("annual_3")}</div>
                    </div>
                </div>

                <div className="pr-grid">
                    {PLANS.map((plan) => {const price = annual ? plan.annual : plan.monthly;
            return (
              <div key={plan.id} className={`pr-card ${plan.featured ? 'is-featured' : ''}`}>
                                <div className="mb-12">
                                    <h3 className="text-sm font-medium tracking-wide uppercase mb-4">{plan.name}</h3>
                                    <p className={`text-sm ${isDarkMode ? 'text-zinc-300' : 'text-zinc-950'} font-light leading-relaxed min-h-[40px]`}>
                                        {plan.desc}
                                    </p>
                                </div>

                                <div className="mb-12">
                                    <div className="flex items-baseline gap-2">
                                        {price !== null ?
                    <>
                                                <span className="editorial-title text-6xl font-normal">${price}</span>
                                                <span className={`text-sm ${isDarkMode ? 'text-zinc-300' : 'text-zinc-950'} font-light`}>{t("mo_5")}</span>
                                            </> :

                    <span className="editorial-title text-6xl font-normal">{t("custom")}</span>
                    }
                                    </div>
                                    {annual && price !== null &&
                  <p className="text-[10px] uppercase tracking-wider text-green-600 font-semibold mt-2">
                                            {t("20_off_annual_billing")}
                                        </p>
                  }
                                </div>

                                <Link to={plan.to} className="pr-btn-main mb-12">
                                    {plan.cta}
                                </Link>

                                <div className="space-y-6 mt-auto">
                                    <ul className="space-y-5">
                                        {plan.features.map((f, i) =>
                    <li key={i} className="flex gap-4 items-start">
                                                <div className="feature-dot" />
                                                <span className="feature-text">{f}</span>
                                            </li>
                    )}
                                    </ul>
                                </div>
                            </div>);

          })}
                </div>
            </div>
        </section>);

}